import script from "./commonPage.vue?vue&type=script&setup=true&lang=js"
export * from "./commonPage.vue?vue&type=script&setup=true&lang=js"

import "./commonPage.vue?vue&type=style&index=0&id=68a93f0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68a93f0a"]])

export default __exports__